import { render, staticRenderFns } from "./Kassenbon.vue?vue&type=template&id=1281512f&"
import script from "./Kassenbon.vue?vue&type=script&lang=js&"
export * from "./Kassenbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports